import format from 'date-fns/format';
import unix from './unix';

/**
 * 时间的友好提示
 * @param int sTime 待显示的时间
 * @param string type  类型 mohu | full | ymd | other
 * @return string
 */
function friendlyTime(sTime, type = 'mohu') {
	//	当前时间
	const nowDate = new Date();
  // cTime=当前时间
	const cTime =	nowDate.getTime();

	const date = nowDate.getDate();
	nowDate.setHours(0);
	nowDate.setMinutes(0);
	nowDate.setMilliseconds(0);
	//	今天零点
	const todayTime = unix(nowDate);
	//	昨天零点
	const yestodayTime = unix(new Date(nowDate.setDate(date - 1)));
	//	明天零点
	const tommrrowTime = unix(new Date(nowDate.setDate(date + 1)));
	//	一周前
	const weekTime = todayTime - 3600 * 24 * 7;
	//	时间差
  const dTime = cTime - sTime;

  if (type == 'mohu') {
		//	10秒内
    if (dTime < 10) {
      return '刚刚';
		}
		
    if (dTime >= 10 && dTime < 60) {
			//	一分钟内
      return dTime + ' 秒前';
    } else if (dTime < 3600) {
			//	一小时内
      return Math.ceil(dTime / 60) + ' 分钟前';
    } else if (sTime < tommrrowTime && sTime > todayTime) {
			//  时间在今天0点到明天0点之间
			
			//	小时数
			let h = Math.ceil(dTime / 3600);
			
      if (Math.ceil((dTime % 3600) / 60) > 30) {
				//	四舍五入
        h++;
			}
			//	大于3小时
      if (h >= 3) {
        return '今天  ' + format(sTime * 1000, 'HH:mm');
      }
      return h + ' 小时前';
    } else if (sTime < todayTime && sTime > weekTime) {
			// 时间在本周0点到今天0点之间
      if (sTime > yestodayTime && sTime < todayTime) {
				// 时间在今天0点到昨天0点之间
        return '昨天 ' + format(sTime * 1000, 'HH:mm');
      } else if (sTime > yestodayTime - 86400 && sTime < yestodayTime) {
        // 时间在前天0点到昨天0点之间
        return '前天 ' + format(sTime * 1000, 'HH:mm');
      } else {
        // 其他
        return format(sTime * 1000, 'MM月DD日 HH:mm');
      }
    } else {
      return format(sTime * 1000, 'MM月DD日 HH:mm');
    }
  } else if (type == 'full') {
    return format(sTime * 1000, 'YY-MM-DD , HH:mm:ss');
  } else if (type == 'ymd') {
    return format(sTime * 1000, 'YY-MM-DD , HH:mm:ss');
  } else {
		return format(sTime * 1000, 'YY-MM-DD , HH:mm:ss');
  }
}

export default friendlyTime;



// WEBPACK FOOTER //
// ./app/web/asset/js/utils/friendlyTime.js